<template>
  <div
    id="callNowModal"
    class="modal modal-geq"
    :class="{ 'is-active': active }"
    @keydown.esc.prevent="closeModal()"
  >
    <div
      class="modal-background"
      @click.prevent="closeModal()"
    />
    <div class="modal-card">
      <div class="modal-form">
        <div class="modal-card-head">
          <p class="modal-card-title">
            Call Now
          </p>
          <button
            class="modal-card-close bg-transparent"
            aria-label="close"
            @click.prevent="closeModal()"
          >
            <i class="fa fa-times fa-lg" />
          </button>
        </div>
        <div class="modal-card-body">
          <div class="call-info-container">
            <p class="call-info-text">
              For the best prices and availability, call us now on
            </p>
            <p class="call-info-days">
              Monday - Friday
            </p>
            <p class="call-info-number">
              <i class="fas fa-phone" />
              <a
                :href="'tel:' + phoneNumber"
                :aria-label="`Call ${phoneNumber} to Book`"
              >
                {{ phoneNumber }}
              </a>
            </p>
            <p class="call-info-action">
              Call to Book
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '../../vue-functions/event-bus';
import { closeModal } from '../../modals/closeModal';

export default {
  data() {
    return {
      active: false,
      phoneNumber: ''
    };
  },
  created() {
    EventBus.$on('TOGGLE_CALL_NOW_MODAL', (payload) => {
      this.phoneNumber = payload && payload.phoneNumber ? String(payload.phoneNumber) : '';
      document.documentElement.classList.add('is-clipped');
      this.show();
    });
  },
  mounted() {
    closeModal(this.closeModal);
  },
  methods: {
    show() {
      this.active = true;
      this.toggleBodyClass();
    },
    toggleBodyClass() {
      let bodyEl = document.querySelector('body');
      bodyEl.classList.toggle('is-modal-active');
    },
    closeModal() {
      this.active = false;
      document.documentElement.classList.remove('is-clipped');
      this.toggleBodyClass();
    }
  }
};
</script>
